module.exports = __webpack_public_path__ + "img/PPT_document_icon@2x.32de9b89.png";